import React, { Component, createRef } from 'react';
import cn from 'classnames';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import styles from './index.module.css';

/**
 * Custom Modal component, that renders modal in the portal
 *
 * @param {Boolean} isOpen is modal opened
 * @param {Function} onClose called on modal close
 * @param {String} modalClassName className prop for modal
 * @param {String} contentClassName className prop for modal content
 * @returns render modal with content
 */

 class Modal extends Component {

  backdropRef = createRef();

  handleEscape = (event) => {
    if (event.keyCode === 27 && this.props.isOpen) {
      this.props.onClose();
    }
  };

  handleBackdropClick = (e) => {
    if (e.target === this.backdropRef.current) {
      this.props.onClose();
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscape);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isOpen } = this.props; 

    if (prevProps.isOpen !== isOpen) {
      const rootElem = document.getElementById('root');
      if (rootElem) {
        if (isOpen) {
          rootElem.style.filter = 'blur(4px)';
          rootElem.style.overflowX = 'hidden';
          document.body.style.overflowY = 'hidden';
        } else {
          rootElem.style.filter = 'none';
          rootElem.style.overflowX = 'auto';
          document.body.style.overflowY = 'auto';
        }
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape);
    const rootElem = document.getElementById('root');
    if (rootElem) {
      rootElem.style.filter = 'none';
      rootElem.style.overflowX = 'auto';
      document.body.style.overflowY = 'auto';
    }
  }

  render() {
    const {
      isOpen,
      modalClassName,
      contentClassName,
      children,
    } = this.props;

    return ReactDOM.createPortal( (
      <CSSTransition
        in={isOpen}
        timeout={300}
        classNames={{
          enterActive: styles.animationEnterActive,
          enter: styles.animationEnter,
          exit: styles.animationExit,
          exitActive: styles.animationExitActive,
        }}
        unmountOnExit
      >
        <div
          ref={this.backdropRef}
          className={styles.backdrop}
          onClick={this.handleBackdropClick}
        >
          <div
            className={cn(styles.modal, modalClassName)}
          >
            <div className={cn(styles.content, contentClassName)}>{children}</div>
          </div>
        </div>
      </CSSTransition>
    ), document.getElementById('modal-wrapper'))
  }
};

export default Modal;
